import styled, { css } from 'styled-components';

export const ContentArea = styled.div`
  margin-top: 88px;
  margin-bottom: 108px;
  margin-right: ${({ theme }) => theme.spacing.m};
  margin-left: ${({ theme }) => theme.spacing.m};
`;

export const DottedBorder = styled.div`
  border-top: 1px dashed ${({ theme }) => theme.colors.platinum};
  position: relative;
  margin: ${({ theme }) => theme.spacing.s} ${({ theme }) => theme.spacing.m};
  width: 100%;
`;

export const DottedBorderText = styled.div`
  background-color: ${({ theme }) => theme.colors.white};
  top: -10px;
  position: absolute;
  left: 40%;
`;

export const ReplayCardContainer = styled.div`
  display: flex;
`;

export const ArrowIconContainer = styled.div`
  display: flex;
  justify-content: right;
  align-items: center;
  margin-left: ${({ level }) => (level > 0 ? level * 24 : 0)}px;
  margin-right: ${({ theme }) => theme.spacing.xs};
`;

export const CardContainer = styled.div(
  ({ theme, isWhite, statusCard }) => css`
    background: ${isWhite ? theme.colors.white : theme.colors.antiFlashWhite};
    box-shadow:
      0px 0.3px 0.9px rgba(0, 0, 0, 0.1),
      0px 1.6px 3.6px rgba(0, 0, 0, 0.13);
    border-radius: ${theme.radius.s};
    width: ${theme.width.full};
    padding: ${theme.spacing.sm};
    margin: ${theme.spacing.m} ${theme.spacing.none};
    border-left: 8px solid
      ${statusCard === 'replyBorderCompleted'
        ? '#219917'
        : statusCard === 'replyBorderRed'
          ? '#EF374E'
          : statusCard === 'replyBorderGreen'
            ? '#8CA7C4'
            : statusCard === 'replyBorderYellow'
              ? '#DEBA12'
              : 'transparent'};
  `
);

export const MessageMainContainer = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing.m};
  display: flex;
  gap: ${({ theme }) => theme.spacing.md};
`;

export const CardInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.xs};
`;

export const CardMessageTitle = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.xs};
`;

export const MessageSenderContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const ButtonContainer = styled.div`
  margin-top: ${({ theme }) => theme.spacing.l};
`;
